import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polygon,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Polygon, { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", stroke: `${color}` })
    }
  );
};
Icon.displayName = "Volume";
const Volume = memo(themed(Icon));
export {
  Volume
};
//# sourceMappingURL=volume.js.map
